// extracted by mini-css-extract-plugin
export default {"menuWrapper":"dhbrm__menuWrapper--bebfd","linkWrapper":"dhbrm__linkWrapper--cbfd6","urlWrapper":"dhbrm__urlWrapper--e1f40"};